import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { AccountService } from '../../account/account.service';
import { isTenantAdmin } from '../../models/user-role.model';

export const tenantAdminGuard: CanActivateFn = () => {
  const accountService = inject(AccountService);
  const router = inject(Router);

  return accountService.getProfile().pipe(
    map((profile) => isTenantAdmin(profile.role) || router.createUrlTree(['/'])),
    catchError(() => of(router.createUrlTree(['/']))),
  );
};
